import React, {useEffect, useState} from "react";

const VoiceReminderTooltip = ({onClose, message}) => {
    const [visible, setVisible] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        if (visible) {
            const timeout = setTimeout(() => {
                handleClose();
            }, 60000);
            return () => clearTimeout(timeout);
        }
    }, [visible]);

    const handleClose = () => {
        setFadeOut(true);
        setTimeout(() => {
            setVisible(false);
            onClose?.();
        }, 300);
    };

    if (!visible) return null;

    return (
        <div
            className={`relative bg-gradient-to-r from-[#8a7ff0] to-[#9c95dc] text-white text-xs min-[550px]:text-sm px-5 py-4 rounded-2xl 
                      shadow-lg mb-3 transition-opacity duration-300 ease-in-out w-44 min-[450px]:w-48 min-[550px]:w-52 min-[704px]:w-60
                      ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
            style={{transform: 'scale(1.25) translateY(25%)', transformOrigin: 'bottom right'}}
        >
            <div className="flex items-center space-x-2">
                {message ? (
                    <span className="font-medium max-w-full break-words">{message}</span>
                ) : (
                    <span className="font-medium max-w-full break-words">Say <strong
                        className="font-bold">"Hi Reco"</strong> to start</span>
                )}
            </div>

            <button
                onClick={handleClose}
                className="absolute top-2 right-2 bg-white/20 hover:bg-white/30 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors duration-200"
                aria-label="Close reminder"
            >
                ✕
            </button>

            <div
                className="absolute bottom-[-6px] right-6 w-3 h-3 bg-[#9c95dc] transform rotate-45 z-[-1] rounded-sm shadow-sm"/>
        </div>
    );
};

export default VoiceReminderTooltip;
